function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#AEAEAE",
  d: "M5 0H10V5H5zM15 0H20V5H15zM25 0H30V5H25zM0 5H5V10H0zM10 5H15V10H10zM20 5H25V10H20zM30 5H35V10H30zM5 10H10V15H5zM15 10H20V15H15zM25 10H30V15H25zM0 15H5V20H0zM10 15H15V20H10zM20 15H25V20H20zM30 15H35V20H30zM5 20H10V25H5zM15 20H20V25H15zM25 20H30V25H25z"
});

var SvgTransparent = function SvgTransparent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    fill: "none",
    viewBox: "0 0 35 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransparent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transparent.b62e725f.svg";
export { ForwardRef as ReactComponent };